import {
  getAllowedContentCountWithoutAccount,
  userDocumentTracking,
  setInfoToLocalStorage,
  getContentCountToStartRenderingBannerNotificatons,
  getShouldShowBannerNotificationsUX,
  getShouldShowReaderBlur,
  handleBannerNotification,
  clearContentAccountGateDataFromLocalStorage,
  localStorageEnabled,
} from "./content-account-gate-common";
import { player } from "../../new_player/selectors";

window.addEventListener('DOMContentLoaded', () => {
  const slideshare_object = window.slideshare_object;
  const slideshow = slideshare_object && slideshare_object.slideshow;
  const slideshowType = slideshow.type;
  const totalSlidesCount = slideshow.total_slides;
  const isUserAuthenticated = slideshare_object.utils.isUserAuthenticated();
  const viewRestrictionAbTestValue = window.ab_tests.viewRestrictionWithoutAccount;
  const viewRestrictionFeatureFlag = window.feature_flags.viewRestrictionsWithoutAccount;
  const supportsLocalStorage = localStorageEnabled();
  let shouldBlurReader = false;

  // Run view gating logic only when the feature flag is enabled and local storage is supported
  if (viewRestrictionFeatureFlag && supportsLocalStorage) {
    if (!isUserAuthenticated && (slideshowType === 'presentation' || slideshowType === 'document') && totalSlidesCount > 1) {
      const allowedContentCount = getAllowedContentCountWithoutAccount();
      const contentAccountGateData = userDocumentTracking({
        slideshowId: slideshow.id,
        allowedContentCount,
        viewRestrictionAbTestValue
      });

      setInfoToLocalStorage(contentAccountGateData, viewRestrictionAbTestValue);
      const contentAccountGateDataLen = contentAccountGateData.length;
      if (viewRestrictionAbTestValue === "show_view_restriction") {
        const contentCountWithoutBannerNotifications = getContentCountToStartRenderingBannerNotificatons();
        const { shouldShowBanner, remainingDocCount } = getShouldShowBannerNotificationsUX(allowedContentCount, contentAccountGateDataLen, contentCountWithoutBannerNotifications);
        shouldBlurReader = getShouldShowReaderBlur(allowedContentCount, contentAccountGateDataLen);

        // Handle UX
        handleBannerNotification(shouldShowBanner, remainingDocCount, slideshare_object);

        if (shouldBlurReader) {
          player.attr('data-shouldblurreader', shouldBlurReader);
        }
      }

      clearContentAccountGateDataFromLocalStorage(viewRestrictionAbTestValue);
    }
  }
});
